import type {
  NodeExecutionStatus,
  NodeExecutionType,
} from "@/types/entities/flows";
import { getRelevantAssignment } from "@/utils/procedures-ui";

export const ALLOWED_NODE_TYPES = new Set([
  "form-node",
  "sign-document-node",
  "payment-node",
  "confirm-associate-user-node",
  "resolution-node",
  // "document-generator-node",
]);

/**
 * Filter to determinate if a node is a form-node with status PENDING, FILL_CORRECTION or IN_PROGRESS
 * to include as action node element
 *
 * @param node
 * @returns true to include the node in the "Próximos pasos clave" section, false to not include it
 */
export const formNodeFilter = (node: NodeExecutionType): boolean => {
  // check for applicants forms
  const formAssignment = getRelevantAssignment(node?.form_assignments);

  if (formAssignment && ["CORRECTION"].includes(formAssignment.status)) {
    return true;
  }

  // check for intern forms
  const userFormAssignment = getRelevantAssignment(node?.user_form_assignments);

  if (
    userFormAssignment &&
    ["IN_PROGRESS", "ASSIGNED"].includes(userFormAssignment.status)
  ) {
    return true;
  }

  return false;
};

export interface KeyNodeType {
  name: string;
  states: Array<NodeExecutionStatus>;
  filter?: (node: NodeExecutionType) => boolean;
}

// add to this list the node and the states of this node that are considered key nodes,
//  for example, a form-node with status PENDING is a key node,
//  but a form-node with status COMPLETED is not a key node
// key nodes are rendered in the "Próximos pasos clave" section,
// while non-key nodes are rendered in the "Pasos de su solicitud" section
export const KEY_NODES_DEF = new Set<KeyNodeType>([
  {
    name: "form-node",
    states: ["PENDING", "COMPLETED"],
    filter: formNodeFilter,
  },
  {
    name: "sign-document-node",
    states: ["PENDING"],
  },
  {
    name: "confirm-associate-user-node",
    states: ["PENDING"],
  },
]);
